export const memberBuyLIst = {
  goDetail: '10671.0'
}
